import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import type { GridFieldHeader } from 'models/forms/fields';
import { FC } from 'react';
import { camelCaseToWords } from 'utils/string';

type Header = Pick<GridFieldHeader, 'id' | 'translationKey'>;

type GridHeadersProps = {
  id: string;
  headers: ReadonlyArray<Header>;
  hasRowIndexColumn: boolean;
};
export const GridHeaders: FC<GridHeadersProps> = ({ id, headers, hasRowIndexColumn }) => {
  return (
    <thead>
      <tr>
        {hasRowIndexColumn && (
          <th key="rowIndex">
            <FormattedMessage id={`form.${id}.periodNumber` as IntlKey} />
          </th>
        )}
        {headers.map(header => {
          const label = header.translationKey ?? header.id;
          return (
            <th key={header.id}>
              <FormattedMessage id={`form.${label}` as any} defaultMessage={camelCaseToWords(label)} />
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

GridHeaders.displayName = 'GridHeaders';
